import { useState } from 'react';
import { MaybeCognitoError } from '@move-frontend/auth';
import { saveUserDetails } from '../../../../shared/account/domain/api/saveUserDetails';
import { IDetailsFormData } from '../../../../shared/account/details/types/IDetailsFormData';

export type FinalSubmitHandler = (
	data: IDetailsFormData,
) => void | Promise<void>;

export function useAccountDetailsSubmit() {
	const [error, setError] = useState<MaybeCognitoError | undefined>(undefined);

	const submit = async (data: IDetailsFormData) => {
		try {
			await saveUserDetails(data);
		} catch (e) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			setError(e);
		}
	};

	return { error, submit };
}
